export default __webpack_public_path__ + "static/media/bgTop.17ed2e23.png";